import { IStandardsSetListViewModel } from "@/search/Langston/types/IStandardsSetListViewModel";
import { IStandardsSetsFetchResponse } from "@/search/Langston/types/IStandardsSetsFetchResponse";

export function convertStandardsSetsFetchToViewModel(
  data: IStandardsSetsFetchResponse[],
): IStandardsSetListViewModel[] {
  return data.length > 0
    ? data.map((set) => ({
        id: set.id,
        title: set.title,
        viewmodel_type: set.viewmodel_type,
        children: set.children.map((child) => ({
          id: child.id,
          adoption_year: Number(child.metadata.document_adopt_year),
          date_created: child.generated_date,
          date_modified: "",
          description: child.description || "",
          is_national: false,
          name: child.metadata.number_enhanced,
          regions: child.metadata.region_codes,
          subjects: [child.metadata.document_primary_subject],
          grade_levels: child.metadata.grades
            ?.map(Number)
            .filter((n) => !isNaN(n)),
          metadata_type: child.metadata.content_type,
        })),
      }))
    : [];
}
